module.exports = __webpack_public_path__ + "static/media/ranking-selected.8fa7cce5.svg";